module.exports = __webpack_public_path__ + "img/henu_app.da9889a9.svg";